import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import {
  DenySign,
  GetSign,
  ResendOnboarding,
  RevokeSign,
} from "../../../store/sign-store/sign-actions";
import { getTokenInfo } from "../../../utils/Guard";
import { DataTable } from "primereact/datatable";
import { TabView, TabPanel } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { signActions } from "../../../store/sign-store/sign-slice";
import { Dropdown } from "primereact/dropdown";
import Loading from "../../../components/UI/Loading";

const SignDetails = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sign = useSelector((state) => state.sign.sign);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();
  const [visiblePopup, setVisiblePopup] = useState(false);
  const [visibleDenyPopup, setVisibleDenyPopup] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (sign.digitalSignRegister === undefined) {
      dispatch(GetSign(param.signpk, userInfo.Email));

    } else {
      setIsLoading(false);
    }
  }, [param.signpk, dispatch, sign.digitalSignRegister]);

  let signData = [];

  if (sign.digitalSignRegister !== undefined) {
    signData = [
      { label: "Pk", value: sign.digitalSignRegister.pk },
      { label: "Instancia", value: sign.digitalSignRegister.instance },
      {
        label: "Solicitado por",
        value: sign.digitalSignRegister.belonging.name,
      },
      {
        label: "Estado",
        value: sign.digitalSignRegister.digitalSignRegisterStatus.name,
      },
      { label: "Comentario", value: sign.digitalSignRegister.razon },
      { label: "Entidad", value: sign.digitalSignRegister.entity },
    ];
  }

  const resendHanlder = () => {
    dispatch(ResendOnboarding(sign.digitalSignRegister.pk, userInfo.Email));
  };
  const revokeHandler = () => {

    dispatch(RevokeSign(sign.digitalSignRegister.pk, userInfo.Email, selectedReason.code, ""));

  };

  const onChangeHandler = (id, value) => {
    dispatch(signActions.modifyPropertyValue({ id, value }));
    if (value !== "") {
      dispatch(signActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(signActions.setFieldValid({ id, value: false }));
    }
  };

  const onChangeReasonHandler = (id, value) => {
    dispatch(signActions.modifyPropertyValue({ id, value: value.code }));
    if (value !== "") {
      dispatch(signActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(signActions.setFieldValid({ id, value: false }));
    }
    setSelectedReason(value);
  };


  const denyHandler = () => {

    dispatch(
      DenySign(
        userInfo.Email,
        param.signpk,
        sign.razon
      )
    );
  };

  const selectedReasonTemplate = (option, props) => {
    if (
      selectedReason &&
      selectedReason.code !== undefined &&
      selectedReason.code !== ""
    ) {


      return <div>{selectedReason.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const Reasons = [
    {
      code: "UNSPECIFIED",
      name: "Sin especificar",
      description: "Unspecified reason",
    },
    {
      code: "KEYCOMPROMISE",
      name: "Compromiso clave",
      description: "Compromised keys",
    },
    {
      code: "AFFILIATIONCHANGED",
      name: "Cambio de afiliación",
      description: "Affiliation changed",
    },
    { code: "SUPERSEDED", name: "Superseded", description: "Superseded" },
    {
      code: "CESSATIONOFOPERATION",
      name: "Cese de operaciones",
      description: "Ceased",
    },
    {
      code: "PRIVILEGESWITHDRAWN",
      name: "Privilegios retirados",
      description: "Privileges withdrawn",
    },
    {
      code: "CERTIFICATEHOLD",
      name: "Certificado en espera",
      description: "Suspend a certificate",
    },
    {
      code: "NOT_REVOKED",
      name: "No revocado",
      description: "Activate a certificate that was suspended",
    },
  ];

  //Belonging Data Table info

  let BelongingData = [];

  if (sign.digitalSignRegister !== undefined) {
    BelongingData = [
      {
        label: "Identifiación",
        value: sign.digitalSignRegister.belonging.identification,
      },
      { label: "Nombre", value: sign.digitalSignRegister.belonging.name },
      {
        label: "Primer Apellido",
        value: sign.digitalSignRegister.belonging.surname1,
      },
      {
        label: "Segundo Apellido",
        value: sign.digitalSignRegister.belonging.surname2,
      },
      { label: "Email", value: sign.digitalSignRegister.belonging.email },
      {
        label: "Teléfono",
        value: sign.digitalSignRegister.belonging.cellPhone,
      },
      { label: "Perfil", value: sign.digitalSignRegister.belonging.profile },
      { label: "Ciudad", value: sign.digitalSignRegister.belonging.city },
      { label: "Dirección", value: sign.digitalSignRegister.belonging.address },
      {
        label: "Organización - Nombre",
        value: sign.digitalSignRegister.belonging.organization.name,
      },
      {
        label: "Organización - Identificador",
        value: sign.digitalSignRegister.belonging.organization.identifier,
      },
      {
        label: "Organización - Ciudad",
        value: sign.digitalSignRegister.belonging.organization.city,
      },
      {
        label: "Organización - Dirección",
        value: sign.digitalSignRegister.belonging.organization.address,
      },
      {
        label: "Organización - Email",
        value: sign.digitalSignRegister.belonging.organization.email,
      },
      // {
      //   label: "Organización - RA",
      //   value: sign.digitalSignRegister.belonging.organization.ra,
      // },
      {
        label: "Tipo de documento - Nombre",
        value: sign.digitalSignRegister.belonging.documentType.name,
      },
      {
        label: "País - Nombre",
        value: sign.digitalSignRegister.belonging.country.name,
      },
      {
        label: "Cargo - Nombre",
        value: sign.digitalSignRegister.belonging.charge.name,
      },
      {
        label: "Departamento - Nombre",
        value: sign.digitalSignRegister.belonging.department.name,
      },
    ];
  }

  //Representative Data Table info

  let RepresentativeData = [];

  if (sign.digitalSignRegister !== undefined) {
    RepresentativeData = [
      {
        label: "Identifiación",
        value: sign.digitalSignRegister.representative.identification,
      },
      { label: "Nombre", value: sign.digitalSignRegister.representative.name },
      {
        label: "Primer Apellido",
        value: sign.digitalSignRegister.representative.surname1,
      },
      {
        label: "Segundo Apellido",
        value: sign.digitalSignRegister.representative.surname2,
      },
      { label: "Email", value: sign.digitalSignRegister.representative.email },
      {
        label: "Teléfono",
        value: sign.digitalSignRegister.representative.cellPhone,
      },
      {
        label: "Perfil",
        value: sign.digitalSignRegister.representative.profile,
      },
      { label: "Ciudad", value: sign.digitalSignRegister.representative.city },
      {
        label: "Dirección",
        value: sign.digitalSignRegister.representative.address,
      },
      {
        label: "Organización - Nombre",
        value: sign.digitalSignRegister.representative.organization.name,
      },
      {
        label: "Organización - Identificador",
        value: sign.digitalSignRegister.representative.organization.identifier,
      },
      {
        label: "Organización - Ciudad",
        value: sign.digitalSignRegister.representative.organization.city,
      },
      {
        label: "Organización - Dirección",
        value: sign.digitalSignRegister.representative.organization.address,
      },
      {
        label: "Organización - Email",
        value: sign.digitalSignRegister.representative.organization.email,
      },
      {
        label: "Organización - RA",
        value: sign.digitalSignRegister.representative.organization.ra,
      },
      {
        label: "Tipo de documento - Nombre",
        value: sign.digitalSignRegister.representative.documentType.name,
      },
      {
        label: "País - Nombre",
        value: sign.digitalSignRegister.representative.country.name,
      },
      {
        label: "Cargo - Nombre",
        value: sign.digitalSignRegister.representative.charge.name,
      },
      {
        label: "Departamento - Nombre",
        value: sign.digitalSignRegister.representative.department.name,
      },
    ];
  }

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <div
        style={{
          backgroundColor: "#133047",
          padding: "1%",
          height: "100%",
          width: "100%",
        }}
      >
        {/* {sign.digitalSignRegister === undefined &&
              sign.digitalSignRegister.belonging === undefined &&
              sign.digitalSignRegister.belonging.id === undefined && (
          <>
            <Loading />
          </>
        )} */}

        {/* <div style={{gap: "1%", height:"100%", display: "flex", width:"93.3%",marginLeft:"2.5%"}}> */}

        {/* {sign.digitalSignRegister !== undefined &&
          sign.digitalSignRegister.belonging !== undefined &&
          sign.digitalSignRegister.belonging.id !== undefined && ( */}
        <Card
          style={{
            backgroundColor: "#F9FAFB",
            marginLeft: "0%",
            boxShadow: "none",
            width: "80vw",
            height: "auto",
          }}
        >
          <Button
            text
            raised
            style={{
              marginLeft: "0%",
              boxShadow: "none",
              height: "auto",
              marginTop: "-10%",
              marginRight: "",
            }}
            label="Regresar"
            icon="pi pi-arrow-left"
            className="p-button-danger"
            onClick={() => {
              navigate("/sign");
            }}
          ></Button>
          <TabView className="signDetailsTabView">
            <TabPanel header="Firma">
              {sign !== undefined &&
                sign.digitalSignRegister !== undefined &&
                sign.digitalSignRegister.belonging.id !== undefined &&
                sign.digitalSignRegister.representative.id !== undefined &&
                signData !== undefined && (
                  <DataTable
                    value={signData}
                    style={{ width: "100% ", padding: "0%" }}
                  >
                    <Column
                      field="label"
                      style={{ width: "50%", textAlign: "right" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                    <Column
                      field="value"
                      style={{ width: "50%", textAlign: "left" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                  </DataTable>
                )}
            </TabPanel>
            <TabPanel header={
              sign.digitalSignRegister !== undefined &&
                sign.digitalSignRegister !== null &&
                sign.digitalSignRegister.belonging !== undefined &&
                sign.digitalSignRegister.belonging !== null &&
                sign.digitalSignRegister.belonging.id !== undefined &&
                sign.digitalSignRegister.belonging.id !== null &&
                sign.digitalSignRegister.belonging.profile === "REPqscdABA" ?
                "Representante" : "Perteneciente"
            }>
              {sign.digitalSignRegister !== undefined &&
                sign.digitalSignRegister.belonging !== undefined &&
                sign.digitalSignRegister.belonging.id !== undefined &&
                BelongingData !== undefined && (
                  <DataTable
                    value={BelongingData}
                    style={{ width: "100% ", padding: "0%" }}
                  >
                    <Column
                      field="label"
                      style={{ width: "50%", textAlign: "right" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                    <Column
                      field="value"
                      style={{ width: "50%", textAlign: "left" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                  </DataTable>
                )}
            </TabPanel>
            <TabPanel header={
              sign.digitalSignRegister !== undefined &&
                sign.digitalSignRegister !== null &&
                sign.digitalSignRegister.belonging !== undefined &&
                sign.digitalSignRegister.belonging !== null &&
                sign.digitalSignRegister.belonging.id !== undefined &&
                sign.digitalSignRegister.belonging.id !== null &&
                sign.digitalSignRegister.belonging.profile === "REPqscdABA" ?
                "Operador" : "Representante"
            }>
              {sign.digitalSignRegister !== undefined &&
                sign.digitalSignRegister.representative !== undefined &&
                sign.digitalSignRegister.representative.id !== undefined &&
                RepresentativeData !== undefined && (
                  <DataTable
                    value={RepresentativeData}
                    style={{ width: "100% ", padding: "0%" }}
                  >
                    <Column
                      field="label"
                      style={{ width: "50%", textAlign: "right" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                    <Column
                      field="value"
                      style={{ width: "50%", textAlign: "left" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                  </DataTable>
                )}
            </TabPanel>
          </TabView>

          {sign !== undefined &&
            sign !== null &&
            sign.digitalSignRegister !== undefined &&
            sign.digitalSignRegister !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id !==
            undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id !== null &&
            (sign.digitalSignRegister.digitalSignRegisterStatus.id === 1 ||
              sign.digitalSignRegister.digitalSignRegisterStatus.id === 3) &&

            (
              <>

                <Button
                  rounded
                  text
                  raised
                  onClick={() => {
                    resendHanlder();
                  }}
                  style={{
                    backgroundColor: "#fff",
                    width: "13%",
                    marginLeft: "2%",
                  }}
                  label="Reenviar"
                  className="p-button-success"
                  icon={
                    notification && notification.status === "pending"
                      ? "pi pi-spin pi-spinner"
                      : "pi pi-check"
                  }
                  disabled={notification && notification.status === "pending"}
                />
              </>
            )}

          {sign !== undefined &&
            sign !== null &&
            sign.digitalSignRegister !== undefined &&
            sign.digitalSignRegister !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id !==
            undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id !== null &&
            (sign.digitalSignRegister.digitalSignRegisterStatus.id === 1 || sign.digitalSignRegister.digitalSignRegisterStatus.id === 2 || sign.digitalSignRegister.digitalSignRegisterStatus.id === 4) &&

            (
              <>
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", marginLeft: "1%" }}
                  label="Denegar"
                  icon="pi pi-times"
                  className="p-button-danger"
                  onClick={() => setVisibleDenyPopup(true)}
                  disabled={
                    sign.digitalSignRegister.digitalSignRegisterStatus.name ===
                    "Rechazado" ||
                    sign.digitalSignRegister.digitalSignRegisterStatus.name ===
                    "Revocado"
                  }
                />
              </>
            )}


          {sign !== undefined &&
            sign !== null &&
            sign.digitalSignRegister !== undefined &&
            sign.digitalSignRegister !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id !==
            undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus.id === 9 && (
              <Button
                rounded
                text
                raised
                onClick={() => setVisiblePopup(true)}
                style={{
                  backgroundColor: "#fff",
                  width: "15%",
                  marginLeft: "2%",
                }}
                label="Revocar"
                className="p-button-danger"
                icon={
                  notification && notification.status === "pending"
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-times"
                }
                disabled={notification && notification.status === "pending"}
              />
            )}
          {sign !== undefined &&
            sign !== null &&
            sign.digitalSignRegister !== undefined &&
            sign.digitalSignRegister !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus.name !==
            undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus.name !==
            null && (
              <Dialog
                header="Revocar Firma"
                visible={visiblePopup}
                style={{ width: "50vw" }}
                onHide={() => {
                  if (!visiblePopup) return;
                  setVisiblePopup(false);
                }}
              >
                <div className="revokeModal">

                  <div className="reasonTitle">
                    <span> Razón </span>
                  </div>

                  <Dropdown
                    value={selectedReason}
                    onChange={(e) => {
                      onChangeReasonHandler("razon", e.value);
                    }}
                    options={Reasons}
                    optionLabel="name"
                    placeholder="Seleccionar Razón"
                    valueTemplate={selectedReasonTemplate}
                    style={{
                      width: "100%",
                      height: "50%",
                    }}
                  />
                  {/* <div className="commentTitle">
                    <span> Comentario</span>
                  </div>

                  <InputTextarea
                    className="commentInput"
                    style={{ width: "100%", display: "block" }}

                    id="comment"
                    placeholder="Comentario"
                    autoResize
                    onChange={(e) => onChangeHandler("comment", e.target.value)}
                    value={sign.comment}
                  /> */}
                  <Button
                    rounded
                    text
                    raised
                    style={{ backgroundColor: "#fff", marginTop: "2%" }}
                    label="Revocar"
                    icon="pi pi-times"
                    className="p-button-danger"
                    onClick={(e) => revokeHandler()}
                    disabled={
                      sign.digitalSignRegister.digitalSignRegisterStatus
                        .name === "Rechazado"
                    }
                  />
                </div>
              </Dialog>
            )}

          {sign !== undefined &&
            sign !== null &&
            sign.digitalSignRegister !== undefined &&
            sign.digitalSignRegister !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus !== null &&
            sign.digitalSignRegister.digitalSignRegisterStatus.name !==
            undefined &&
            sign.digitalSignRegister.digitalSignRegisterStatus.name !==
            null && (
              <Dialog
                header="Denegar Firma"
                visible={visibleDenyPopup}
                style={{ width: "50vw", display: "block" }}
                onHide={() => {
                  if (!visibleDenyPopup) return;
                  setVisibleDenyPopup(false);
                }}
              >
                <div className="revokeModal">
                  <div className="commentTitle">
                    <span> Comentario</span>
                  </div>

                  <InputTextarea
                    style={{ width: "100%", display: "block" }}
                     onChange={(e) => onChangeHandler("razon", e.target.value)}
                  />
                  <Button
                    rounded
                    text
                    raised
                    style={{ backgroundColor: "#fff", marginTop: "2%" }}
                    label="Denegar"
                    icon="pi pi-times"
                    className="p-button-danger"
                    onClick={(e) => denyHandler()}
                    disabled={
                      sign.digitalSignRegister.digitalSignRegisterStatus.name === "Rechazado"
                    }
                  />
                </div>
              </Dialog>
            )}
        </Card>
      </div>
    </>
  );
};
export default SignDetails;
